import { useCallback } from 'react'
import { AdminUser } from '../../types/auth'
import { Button } from '../../components/ui/Button'
import { IntegrationProvider, UserActions } from './useUserActions'

interface Props {
  item: AdminUser
  actions: UserActions
}

/** The same action set on the users table and on the user detail page */
export function UserActionButtons({ item, actions }: Props) {
  const handleEdit = useCallback(() => actions.openEdit(item), [item, actions])
  const handleResetPassword = useCallback(() => actions.openResetPassword(item), [item, actions])
  const handleDeactivate = useCallback(() => actions.deactivate(item), [item, actions])
  const handleToggleSupport = useCallback(
    () => actions.toggleSupportRestricted(item),
    [item, actions]
  )
  const clear = useCallback(
    (provider: IntegrationProvider) => () => actions.clearIntegration(item, provider),
    [item, actions]
  )

  return (
    <>
      <Button variant="ghost" size="sm" onClick={handleEdit}>
        Edit
      </Button>
      <Button variant="ghost" size="sm" onClick={handleResetPassword}>
        Reset pw
      </Button>
      {item.integrations.google && (
        <Button variant="ghost" size="sm" onClick={clear('google')}>
          Clear Google
        </Button>
      )}
      {item.integrations.apple && (
        <Button variant="ghost" size="sm" onClick={clear('apple')}>
          Clear Apple
        </Button>
      )}
      <Button
        variant={item.supportRestricted ? 'ghost' : 'danger'}
        size="sm"
        onClick={handleToggleSupport}
      >
        {item.supportRestricted ? 'Unblock support' : 'Block support'}
      </Button>
      {item.active && (
        <Button variant="danger" size="sm" onClick={handleDeactivate}>
          Deactivate
        </Button>
      )}
    </>
  )
}
